import React, { useEffect, useState } from "react";
import {
  FaClock,
  FaTags,
  FaRupeeSign,
  FaPhoneAlt,
  FaFire,
  FaDollarSign,
} from "react-icons/fa";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import axios from "axios";
import axios from "../../context/axios";

const WhyBookWithUs = () => {
  const [selected, setSelected] = useState(0);
  const [slidePercentage, setSlidePercentage] = useState(100);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get("reviews");
        console.log("Fetched reviews:", res.data.reviews.length);
        setReviews(res.data.reviews);
      } catch (err) {
        console.error("Failed to load reviews", err);
      }
    };
    fetchReviews();
  }, []);

  useEffect(() => {
    const updateSlidePercentage = () => {
      const width = window.innerWidth;
      if (width >= 1280) setSlidePercentage(33.33);
      else if (width >= 768) setSlidePercentage(50);
      else setSlidePercentage(100);
    };

    updateSlidePercentage();
    window.addEventListener("resize", updateSlidePercentage);
    return () => window.removeEventListener("resize", updateSlidePercentage);
  }, []);

  const features = [
    {
      icon: <FaClock className="text-4xl text-blue-600 mb-2" />,
      title: "Easy Booking",
      description:
        "We offer easy and convenient flight bookings with attractive offers.",
    },
    {
      icon: <FaTags className="text-4xl text-blue-600 mb-2" />,
      title: "Lowest Price",
      description:
        "We ensure low rates on hotel reservation, holiday packages and flight tickets.",
    },
    {
      icon: <FaDollarSign className="text-4xl text-blue-600 mb-2" />,
      title: "Instant Refund",
      description:
        "Get instant refunds effortlessly on your travel bookings with us.",
    },
    {
      icon: <FaPhoneAlt className="text-4xl text-blue-600 mb-2" />,
      title: "24/7 Support",
      description:
        "Get assistance 24/7 on any kind of travel related query. We are happy to assist you.",
    },
    {
      icon: <FaFire className="text-4xl text-blue-600 mb-2" />,
      title: "Exciting Deals",
      description:
        "Enjoy exciting deals on flights, hotels, buses, car rental and tour packages.",
    },
  ];

  return (
    <div className="px-10 py-12 max-w-7xl mx-auto">
      <h2 className="text-4xl font-bold text-center text-gray-800 mb-14">
        Why Book With Us?
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-16">
        {features.map((feature, idx) => (
          <div
            key={idx}
            className="bg-white text-center p-6 border rounded-xl shadow-lg hover:shadow-xl transition"
          >
            <div className="flex justify-center">{feature.icon}</div>
            <h3 className="font-semibold text-xl mt-4 mb-2 text-gray-900">
              {feature.title}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
      {reviews.length >= 3 && (
  <>
      {/* <div className="max-w-6xl mx-auto py-12 px-6 rounded-lg"> */}
      <div className="px-10 py-12 max-w-7xl mx-auto">

        <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-12 tracking-tight">
          What Our Customers Say
        </h2>

        {reviews.length > 0 ? (
          <Carousel
            selectedItem={selected}
            onChange={(index) => {
              // clamp index so it doesn't exceed 4 (since we only show 5 reviews)
              setSelected(index > 4 ? 4 : index);
            }}
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
            infiniteLoop={false}
            centerMode={reviews.length >= 3} // enable centerMode only if 3 or more reviews
            centerSlidePercentage={slidePercentage}
            // swipeable
            // emulateTouch
            renderArrowPrev={(onClickHandler, hasPrev) =>
              hasPrev && (
                <button
                  onClick={onClickHandler}
                  className="absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-md hover:bg-green-100 transition text-green-600 text-3xl font-bold z-30"
                  aria-label="Previous Review"
                >
                  ‹
                </button>
              )
            }
            renderArrowNext={(onClickHandler, hasNext) =>
              hasNext && (
                <button
                  onClick={onClickHandler}
                  className="absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-md hover:bg-green-100 transition text-green-600 text-3xl font-bold z-30"
                  aria-label="Next Review"
                >
                  ›
                </button>
              )
            }
          >
            {reviews.slice(0, 5).map((review, index) => (
              <div
                key={review._id}
                // className={`px-4 flex justify-center transition-transform duration-300 ease-in-out ${
                //   selected === index
                //     ? "scale-95 z-40"
                //     : "scale-90 opacity-80 z-10"
                // }`}
                className="px-4 flex justify-center"
              >
                <article className="bg-white rounded-2xl shadow-xl border border-gray-200 w-full max-w-xs md:max-w-sm lg:max-w-md p-6 flex flex-col justify-between text-gray-800 h-60">
                  <div className="flex items-center mb-5 space-x-1">
                    {[...Array(review.rating)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 text-green-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.193 3.674a1 1 0 00.95.69h3.862c.969 0 1.371 1.24.588 1.81l-3.124 2.27a1 1 0 00-.364 1.118l1.193 3.674c.3.921-.755 1.688-1.54 1.118L10 13.347l-3.124 2.27c-.785.57-1.84-.197-1.54-1.118l1.193-3.674a1 1 0 00-.364-1.118L3.041 9.101c-.783-.57-.38-1.81.588-1.81h3.862a1 1 0 00.95-.69l1.193-3.674z" />
                      </svg>
                    ))}
                    <span className="ml-2 text-sm font-semibold text-gray-500 tracking-wide">
                      Verified
                    </span>
                  </div>

                  <h3
                    className="font-semibold text-lg mb-2 line-clamp-2"
                    title={review.title}
                  >
                    {review.title}
                  </h3>

                  <p
                    className="text-gray-600 text-sm flex-grow overflow-hidden line-clamp-5"
                    title={review.description}
                  >
                    {review.description}
                  </p>
                  <footer className="mt-6 text-right text-xs text-gray-500 font-semibold tracking-wide">
                    — {review.user?.name || "Anonymous"},{" "}
                    {new Date(review.createdAt).toLocaleDateString()}
                  </footer>
                </article>
              </div>
            ))}
          </Carousel>
        ) : (
          <p className="text-center text-gray-500">No reviews available.</p>
        )}
      </div>
      </>
)}
    </div>
  );
};

export default WhyBookWithUs;
